import React from "react";
import TreeSelect from "../tree-select";

const CellTreeSelect = (props) => {
  return (
    <div className="ag-grid-tree-select">
      <TreeSelect {...props} />
    </div>
  );
};

export default CellTreeSelect;
